import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import * as XLSX from 'xlsx';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';

import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import filtrarUsuarioIA from '../../FuncoesGerais/filtrarUsuarioIA';
import { getAnalistaDisplayNome } from '../../FuncoesGerais/tipoAnalista';
import { ensureProtocol } from '../../config/backend';
import { useTiposChamado } from '../../hooks/useTiposChamado';
import { useStatusChamado } from '../../hooks/useStatusChamado';
import FiltrosSalvos from '../Components/FiltrosSalvos/FiltrosSalvos';

import './relatorioChamadosAberto.css';

function RelatorioChamadosAberto() {
    const history = useHistory();
    const { tipos, getNome: getNomeTipo } = useTiposChamado();
    const { statusParaSelect, getNome: getNomeStatus } = useStatusChamado();

    const [analistas, setAnalistas] = useState([]);
    const [chamados, setChamados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtroTipos, setFiltroTipos] = useState([]);
    const [filtroAtendentes, setFiltroAtendentes] = useState([]);
    const [filtroStatusLista, setFiltroStatusLista] = useState([]);
    const [datIni, setDatIni] = useState('');
    const [datFin, setDatFin] = useState('');
    const [equipeVisualizacao, setEquipeVisualizacao] = useState({ equipe_ids: null });

    // Filtros salvos (Fase 5A): serializa/aplica o estado atual de filtros.
    const definicaoFiltroAtual = {
        filtroTipos,
        filtroAtendentes,
        filtroStatusLista,
        datIni,
        datFin,
    };
    const aplicarFiltroSalvo = (def) => {
        if (!def || typeof def !== 'object') return;
        setFiltroTipos(Array.isArray(def.filtroTipos) ? def.filtroTipos : []);
        setFiltroAtendentes(Array.isArray(def.filtroAtendentes) ? def.filtroAtendentes : []);
        setFiltroStatusLista(Array.isArray(def.filtroStatusLista) ? def.filtroStatusLista : []);
        setDatIni(typeof def.datIni === 'string' ? def.datIni : '');
        setDatFin(typeof def.datFin === 'string' ? def.datFin : '');
    };

    const verificar = async () => {
        const resultado = await verificandoApp('ATENDENTE');
        if (!resultado) history.push('/');
    };

    function aplicarMascaraData(valor) {
        if (!valor) return '';
        const numeros = valor.replace(/\D/g, '').slice(0, 8);
        if (numeros.length <= 2) return numeros;
        if (numeros.length <= 4) return `${numeros.slice(0, 2)}/${numeros.slice(2)}`;
        return `${numeros.slice(0, 2)}/${numeros.slice(2, 4)}/${numeros.slice(4)}`;
    }

    const parseDataBr = (str) => {
        if (!str || typeof str !== 'string') return null;
        const [d, m, a] = str.trim().split(/[/\-.]/);
        if (!d || !m || !a) return null;
        const day = parseInt(d, 10);
        const month = parseInt(m, 10) - 1;
        const year = parseInt(a.length === 2 ? '20' + a : a, 10);
        const date = new Date(year, month, day);
        return isNaN(date.getTime()) ? null : date;
    };

    const carregarAnalistas = async () => {
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(
                ensureProtocol(localStorage.getItem('ipBackend2')) + '/usuarios/analistas',
                { headers: { Authorization: `${token}` } }
            );
            const lista = filtrarUsuarioIA(Array.isArray(response.data) ? response.data : [], 'USRNOMCPL');
            setAnalistas(lista.map((u) => ({
                sequencia: u.USUSEQ ?? u.sequencia,
                nome: u.USRNOMCPL ?? u.nome ?? '',
                tipo_analista: u.tipo_analista ?? null,
                eh_suporte: u.eh_suporte,
                eh_desenvolvedor: u.eh_desenvolvedor,
            })));
        } catch (e) {
            console.error('Erro ao carregar analistas:', e);
            setAnalistas([]);
        }
    };

    const carregarEquipeVisualizacao = async () => {
        const baseUrl = ensureProtocol(localStorage.getItem('ipBackend2') || '');
        const token = localStorage.getItem('token');
        if (!baseUrl || !token) {
            setEquipeVisualizacao({ equipe_ids: '' });
            return;
        }
        try {
            const res = await axios.get(baseUrl + '/usuarios/equipe-visualizacao', { headers: { Authorization: token } });
            const d = res.data || {};
            setEquipeVisualizacao({ equipe_ids: d.equipe_ids != null ? d.equipe_ids : '' });
        } catch (e) {
            console.error('Erro ao carregar equipe de visualização:', e);
            setEquipeVisualizacao({ equipe_ids: '' });
        }
    };

    const buscarChamados = async () => {
        verificar();
        setLoading(true);
        setChamados([]);
        verificandoToken();
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('codUsu');

        const equipe = (equipeVisualizacao.equipe_ids != null && String(equipeVisualizacao.equipe_ids).trim() !== ''
            ? String(equipeVisualizacao.equipe_ids).trim()
            : (localStorage.getItem('equpe') || localStorage.getItem('equipe') || '')).trim();

        let colab = '1,' + user;
        if (filtroAtendentes.length > 0) {
            colab = '1,' + filtroAtendentes.join(',');
        } else if (equipe) {
            colab = '1,' + equipe.split(',').map((c) => c.trim()).filter(Boolean).join(',');
        } else if (analistas.length) {
            colab = '1,' + analistas.map((a) => a.sequencia).join(',');
        }

        try {
            const response = await axios.get(
                ensureProtocol(localStorage.getItem('ipBackend2')) + '/satis',
                {
                    headers: { Authorization: `${token}` },
                    params: { user, colab, descr: '', solici: '' }
                }
            );
            const raw = Array.isArray(response.data) ? response.data : [];
            let lista = raw.map((r) => ({
                id: r.id,
                numero: r.id,
                descricao: r.descricao || '',
                area: r.SATARESOL ?? r.area ?? '',
                data: r.data,
                dataAbertura: r.data,
                status: r.SATSTASAI ?? r.status,
                statusNome: getNomeStatus(r.SATSTASAI ?? r.status),
                atendente: r.atendente,
                nomeAtendente: r.USRNOMCPL ?? r.nomeAte ?? '',
                codSolicitante: r.codSolicitante,
                solicitante: r.solicitante ?? '',
                tipo: r.SATTIP ?? r.tipo,
                tipoNome: getNomeTipo(r.SATTIP ?? r.tipo),
                prioridade: r.SATPRINUM ?? r.prioridade
            }));

            if (filtroTipos.length > 0) {
                const setTipo = new Set(filtroTipos.map(Number));
                lista = lista.filter((c) => c.tipo != null && setTipo.has(Number(c.tipo)));
            }
            if (filtroStatusLista.length > 0) {
                const setStatus = new Set(filtroStatusLista.map(Number));
                lista = lista.filter((c) => c.status != null && setStatus.has(Number(c.status)));
            }
            if (datIni && datIni.trim()) {
                const dIni = parseDataBr(datIni);
                if (dIni) {
                    dIni.setHours(0, 0, 0, 0);
                    lista = lista.filter((c) => {
                        const dt = c.data ? new Date(c.data) : null;
                        return dt && dt >= dIni;
                    });
                }
            }
            if (datFin && datFin.trim()) {
                const dFin = parseDataBr(datFin);
                if (dFin) {
                    dFin.setHours(23, 59, 59, 999);
                    lista = lista.filter((c) => {
                        const dt = c.data ? new Date(c.data) : null;
                        return dt && dt <= dFin;
                    });
                }
            }

            setChamados(lista);
        } catch (error) {
            setChamados([]);
            console.error('Erro ao buscar chamados:', error);
            alert(error?.response?.data?.error || 'Erro ao carregar chamados. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    const exportarExcel = () => {
        if (chamados.length === 0) {
            alert('Não há dados para exportar. Execute a pesquisa primeiro.');
            return;
        }
        const colunas = [
            { header: 'Número', key: 'numero' },
            { header: 'Data abertura', key: 'dataAbertura' },
            { header: 'Tipo', key: 'tipoNome' },
            { header: 'Descrição', key: 'descricao' },
            { header: 'Solicitante', key: 'solicitante' },
            { header: 'Atendente', key: 'nomeAtendente' },
            { header: 'Status', key: 'statusNome' },
            { header: 'Área', key: 'area' }
        ];
        const rows = chamados.map((c) => {
            const obj = {};
            colunas.forEach((col) => { obj[col.header] = c[col.key] ?? ''; });
            return obj;
        });
        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Chamados em aberto');
        const nomeArquivo = `relatorio_chamados_abertos_${new Date().toISOString().slice(0, 10)}.xlsx`;
        XLSX.writeFile(wb, nomeArquivo);
    };

    useEffect(() => {
        verificar();
        carregarEquipeVisualizacao();
        carregarAnalistas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid relatorio-chamados-aberto">
                    <div className="page-header relatorio-chamados-aberto-header">
                        <h1>Relatório – Chamados em aberto</h1>
                        <p className="text-muted relatorio-chamados-aberto-desc">
                            Filtre por tipo, atendente e status e exporte em Excel para envio à diretoria.
                        </p>
                    </div>

                    <div className="relatorio-chamados-aberto-filtros card mb-4">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                                <h5 className="card-title mb-0"><i className="fas fa-filter me-2" />Filtros</h5>
                                <FiltrosSalvos
                                    escopo="chamados-abertos"
                                    definicaoAtual={definicaoFiltroAtual}
                                    onAplicar={aplicarFiltroSalvo}
                                />
                            </div>
                            <div className="relatorio-chamados-aberto-filtros-grid">
                                <div className="relatorio-chamados-aberto-filtro-col">
                                    <label className="form-label">Tipo do chamado</label>
                                    <div className="relatorio-chamados-aberto-multiselect">
                                        <div className="relatorio-chamados-aberto-multiselect-acoes">
                                            <button type="button" className="btn btn-link btn-sm p-0 me-2" onClick={() => setFiltroTipos((tipos || []).map((t) => t.id))}>Todos</button>
                                            <button type="button" className="btn btn-link btn-sm p-0" onClick={() => setFiltroTipos([])}>Limpar</button>
                                        </div>
                                        <div className="relatorio-chamados-aberto-multiselect-list">
                                            {(tipos || []).map((t) => (
                                                <label key={t.id} className="relatorio-chamados-aberto-check">
                                                    <input type="checkbox" checked={filtroTipos.includes(t.id)} onChange={(e) => { if (e.target.checked) setFiltroTipos((prev) => [...prev, t.id]); else setFiltroTipos((prev) => prev.filter((id) => id !== t.id)); }} />
                                                    <span>{t.nome}</span>
                                                </label>
                                            ))}
                                        </div>
                                        {filtroTipos.length > 0 && <small className="text-muted">{filtroTipos.length} selecionado(s)</small>}
                                    </div>
                                </div>
                                <div className="relatorio-chamados-aberto-filtro-col">
                                    <label className="form-label">Atendente</label>
                                    <div className="relatorio-chamados-aberto-multiselect">
                                        <div className="relatorio-chamados-aberto-multiselect-acoes">
                                            <button type="button" className="btn btn-link btn-sm p-0 me-2" onClick={() => setFiltroAtendentes(analistas.map((a) => a.sequencia))}>Todos</button>
                                            <button type="button" className="btn btn-link btn-sm p-0" onClick={() => setFiltroAtendentes([])}>Limpar</button>
                                        </div>
                                        <div className="relatorio-chamados-aberto-multiselect-list">
                                            {analistas.map((a) => (
                                                <label key={a.sequencia} className="relatorio-chamados-aberto-check">
                                                    <input type="checkbox" checked={filtroAtendentes.includes(a.sequencia)} onChange={(e) => { if (e.target.checked) setFiltroAtendentes((prev) => [...prev, a.sequencia]); else setFiltroAtendentes((prev) => prev.filter((id) => id !== a.sequencia)); }} />
                                                    <span>{getAnalistaDisplayNome(a.nome, a)}</span>
                                                </label>
                                            ))}
                                        </div>
                                        {filtroAtendentes.length > 0 && <small className="text-muted">{filtroAtendentes.length} selecionado(s)</small>}
                                    </div>
                                </div>
                                <div className="relatorio-chamados-aberto-filtro-col">
                                    <label className="form-label">Status</label>
                                    <div className="relatorio-chamados-aberto-multiselect">
                                        <div className="relatorio-chamados-aberto-multiselect-acoes">
                                            <button type="button" className="btn btn-link btn-sm p-0 me-2" onClick={() => setFiltroStatusLista((statusParaSelect || []).map((s) => s.codigo_legado))}>Todos</button>
                                            <button type="button" className="btn btn-link btn-sm p-0" onClick={() => setFiltroStatusLista([])}>Limpar</button>
                                        </div>
                                        <div className="relatorio-chamados-aberto-multiselect-list">
                                            {(statusParaSelect || []).map((s) => (
                                                <label key={s.id} className="relatorio-chamados-aberto-check">
                                                    <input type="checkbox" checked={filtroStatusLista.includes(s.codigo_legado)} onChange={(e) => { if (e.target.checked) setFiltroStatusLista((prev) => [...prev, s.codigo_legado]); else setFiltroStatusLista((prev) => prev.filter((c) => c !== s.codigo_legado)); }} />
                                                    <span>{s.nome}</span>
                                                </label>
                                            ))}
                                        </div>
                                        {filtroStatusLista.length > 0 && <small className="text-muted">{filtroStatusLista.length} selecionado(s)</small>}
                                    </div>
                                </div>
                                <div className="relatorio-chamados-aberto-periodo">
                                    <label className="form-label">Período (opcional)</label>
                                    <div className="relatorio-chamados-aberto-datas">
                                        <div className="relatorio-chamados-aberto-data-field">
                                            <label className="form-label small text-muted">Data inicial</label>
                                            <input type="text" className="form-control" placeholder="dd/mm/aaaa" value={datIni} onChange={(e) => setDatIni(aplicarMascaraData(e.target.value))} aria-label="Data inicial" />
                                        </div>
                                        <span className="relatorio-chamados-aberto-data-sep" aria-hidden="true">até</span>
                                        <div className="relatorio-chamados-aberto-data-field">
                                            <label className="form-label small text-muted">Data final</label>
                                            <input type="text" className="form-control" placeholder="dd/mm/aaaa" value={datFin} onChange={(e) => setDatFin(aplicarMascaraData(e.target.value))} aria-label="Data final" />
                                        </div>
                                    </div>
                                </div>
                                <div className="relatorio-chamados-aberto-acoes">
                                    <button type="button" className="btn btn-primary" onClick={buscarChamados} disabled={loading}>
                                        {loading ? <><i className="fas fa-spinner fa-spin me-1" /> Pesquisando...</> : <><i className="fas fa-search me-1" /> Pesquisar</>}
                                    </button>
                                    <button type="button" className="btn btn-success" onClick={exportarExcel} disabled={loading || chamados.length === 0}>
                                        <i className="fas fa-file-excel me-1" /> Exportar Excel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="relatorio-chamados-aberto-tabela card">
                        <div className="card-body">
                            <h5 className="card-title">Resultado ({chamados.length} chamado(s))</h5>
                            {loading && chamados.length === 0 ? (
                                <div className="text-center py-5 text-muted">
                                    <i className="fas fa-spinner fa-spin fa-2x mb-2" />
                                    <p className="mb-0">Carregando...</p>
                                </div>
                            ) : chamados.length === 0 ? (
                                <div className="text-center py-5 text-muted">
                                    <i className="fas fa-inbox fa-2x mb-2" />
                                    <p className="mb-0">Nenhum chamado encontrado. Ajuste os filtros e clique em Pesquisar.</p>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover table-striped align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Data abertura</th>
                                                <th>Tipo</th>
                                                <th>Descrição</th>
                                                <th>Solicitante</th>
                                                <th>Atendente</th>
                                                <th>Status</th>
                                                <th>Área</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {chamados.map((c) => (
                                                <tr key={c.id}>
                                                    <td>{c.numero}</td>
                                                    <td>{c.dataAbertura ? new Date(c.dataAbertura).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—'}</td>
                                                    <td>{c.tipoNome || '—'}</td>
                                                    <td className="text-break" title={c.descricao}>{c.descricao ? (c.descricao.length > 60 ? c.descricao.slice(0, 60) + '…' : c.descricao) : '—'}</td>
                                                    <td>{c.solicitante || '—'}</td>
                                                    <td>{c.nomeAtendente || '—'}</td>
                                                    <td>{c.statusNome || '—'}</td>
                                                    <td>{c.area === 'I' ? 'Infraestrutura' : c.area === 'S' ? 'Sistemas' : c.area || '—'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default RelatorioChamadosAberto;
